<template>
    <v-container class="mt-4">
        <v-col cols="12">
            <div class="heading text-center" style="font-weight: 200 !important;">
                <slot></slot>
            </div>
            <span class="heading-underscore"></span>
        
        <!--
        <div
            class="strip_container"
            style="position: relative;"
        >
            <multi-color-strip
                :colors="colors"
                :number="9"
            />
            <span class="text">{{ year }}</span>
        </div>
        -->
        </v-col>
    </v-container>
</template>

<script>

export default {
    name: "Title",
    props: ["title", "year"],
    data: () => ({
        colors: ["#F7F02D", "#E1EC36", "#A3CF39", "#57C26D", "#1F965A", "#216D62", "#0F6578", "#0F4878", "#042A89"]
    })
}
</script>

<style lang="scss" scoped>
.text {
  font-size: 140pt;
  font-family: sans-serif;
  font-weight: 700;
  color: rgb(230, 230, 230);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}

.strip_container {
  &::after,
  &::before {
    content: "";
    background-color: white;
    height: 20px;
    width: 100%;
    position: absolute;
    z-index: 999;
  }

  &::before {
    margin-top: -20px;
  }
}

.heading {
  font-family: "Roboto";
  font-size: 2.75rem;
  text-align: center;
  font-weight: 300;
  line-height: 2.75rem;
  letter-spacing: 0.0083333333em !important;
}

.heading-underscore {
  margin-top: 10px;
  height: 2px;
  width: 100px;
  display: block;
  background-color: $primary-color;
  margin-left: auto;
  margin-right: auto;
}

@media (min-width: 960px) {
  .heading {
    font-size: 3.75rem;
    line-height: 3.75rem;
  }

  .heading-underscore {
    margin-top: 15px;
    height: 2px;
    width: 200px;
  }
}
</style>